"use strict";

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ContactElement = _interopRequireDefault(require("../ContactElement"));

var Call = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(Call, _React$PureComponent);

  function Call() {
    (0, _classCallCheck2["default"])(this, Call);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Call).apply(this, arguments));
  }

  (0, _createClass2["default"])(Call, [{
    key: "getCallLink",
    value: function getCallLink() {
      var phoneNumber = this.props.phoneNumber;
      var phoneNumberStripped = phoneNumber.replace(' ', '').replace(')', '').replace('(', '').replace('-', '').replace('—', '').replace('+', '');
      return "tel:+".concat(phoneNumberStripped);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          phoneNumber = _this$props.phoneNumber,
          as = _this$props.as,
          header = _this$props.header,
          iconPosition = _this$props.iconPosition,
          showIcon = _this$props.showIcon,
          buttonColor = _this$props.buttonColor,
          className = _this$props.className,
          fluidButton = _this$props.fluidButton,
          buttonSize = _this$props.buttonSize;
      return _react["default"].createElement(_ContactElement["default"], {
        contact: phoneNumber,
        link: this.getCallLink(),
        iconType: showIcon || as === 'icon' ? 'phone' : 'none',
        as: as,
        header: header,
        className: className,
        buttonColor: buttonColor,
        iconPosition: iconPosition,
        fluidButton: fluidButton,
        buttonSize: buttonSize
      });
    }
  }]);
  return Call;
}(_react["default"].PureComponent);

exports["default"] = Call;
Call.propTypes = {
  phoneNumber: _propTypes["default"].string.isRequired,
  as: _propTypes["default"].oneOf(['text', 'button', 'icon']),
  buttonColor: _propTypes["default"].string,
  buttonSize: _propTypes["default"].string,
  className: _propTypes["default"].string,
  fluidButton: _propTypes["default"].bool,
  header: _propTypes["default"].string,
  iconPosition: _propTypes["default"].string,
  showIcon: _propTypes["default"].bool
};
Call.defaultProps = {
  as: 'text',
  buttonColor: 'default',
  buttonSize: 'large',
  className: '',
  fluidButton: false,
  header: '',
  iconPosition: 'left',
  showIcon: false
};
Call.propOptions = {
  header: ['Call Us', ''],
  buttonColor: ['primary', 'secondary', 'default'],
  iconPosition: ['left', 'top']
};
Call.dataPropsMap = {
  phoneNumber: ['business', 'primary_location', 'phone_number']
};